export const IMAGE_FOLDERS = {
    ICONS: 'icons',
} as const;